import request from "@/utils/request";
import { useDeviceStore } from '@/store/home'
// 示例
// export function getDepartment(departmentId) {
//   return request({
//     url: `/h5/documentSelf/departmentById/${departmentId}`,
//     method: 'GET'
//   })
// }

export function updateApplyFile(params) {
    return request({
        url: "/wechat/examine/updateApplyFile",
        method: "PUT",
        data:params,
    });
}

// 获取用印管理列表
export function getSealLists(params) {
    return request({
        url: "/wechat/manage/document/show/v2.5.9",
        method: "GET",
        params,
    });
}

// 获取用印管理详情
export function getSealView(id) {
    return request({
        url: `/wechat/record/document/details/${id}/v2.5.9`,
        method: "GET",
    });
}

//v3.0申请详情
export const getSealDetail = (params) => {
    return request({
        url: `/wechat/manage/document/details/${params.documentId}`,
        method: "GET",
        params,
    });
};

// v3.7.1 用印详情页
export const getDocumentDetail = (documentId) => {
    return request({
        url: `/wechat/record/document/detail?documentId=${documentId}`,
        // url: `${'https://yapi.libawall.com/mock/1543'}/pc/sealComplete/document/detail`,
        method: "GET"
    });
};

//用印影像查询
export const getDocumentFiles = (params) => {
    return request({
        url: `/common/document/files`,
        method: "GET",
        params
    });
};

//v3.0获取文件地址
export const getFile = (params) => {
    return request({
        url: "/file",
        method: "GET",
        params,
    });
};

// 获取电子印章用印管理详情
export function getElectronicSealSeal(id) {
    return request({
        url: `/wechat/qys/apply/details/${id}`,
        method: "GET",
    });
}

//获取文件大小
export function getSealFile(id) {
    return request({
        url: `/file/${id}`,
        method: "GET",
    });
}

// 撤销申请
export function applyBackout(id) {
    return request({
        url: `/wechat/manage/backout/${id}`,
        method: "PUT",
    });
}

// 撤销用印申请理由(v2.6.3新增)
//撤销申请v3.0
export function revocationReason(params) {
    return request({
        url: "/wechat/manage/withdraw",
        method: "PUT",
        params,
    });
}

// 通过文件id 获取 印章设备数据
export async function getSeals(id, loginSource) {
    const deviceStore = useDeviceStore()
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let r = await request({
        url: `/wechat/home/seal/details/${id}`,
        method: "GET",
        params: {
            version: 'v3.4.1',
            loginSource: loginSource || (userInfo.loginType === 18 ? 1 : undefined)
        }
    });
    if (r.success && r.data[0]) {
        deviceStore.secretSealProcess = r.data[0]['secretSealProcess'] == 1
    }
    return r
}

// 查询是否补拍状态
export function getReshootStatus(documentId) {
    return request({
        url: `/wechat/home/document/make_up/status?documentId=${documentId}`,
        method: "GET",
    });
}

// 文件属性
export function checkDocumenType(id) {
    return request({
        url: `/wechat/home/document/type/${id}`,
        method: "GET",
    });
}

export async function fenceStatus(documentId, sealId) {
    const deviceStore = useDeviceStore()
    let r = await request({
        // url: `/wechat/home/document/seal/type/${documentId}/${sealId}`,
        url: `/wechat/home/seal/check/${documentId}/${sealId}`,
        method: "GET",
    });
    if (r.success) {
        deviceStore.secretSealProcess = r.data['secretSealProcess'] == 1
    }
    return r
}

// 获取当前员工可用流程

export function getAvailable(params) {
    return request({
        url: "/wechat/home/available",
        method: "GET",
        params
    });
}
// 根据模板ID获取流程动态表单信息
export function getAvailableFormItems(params) {
    return request({
        url: `/wechat/workspace/process/detail`,
        method: "GET",
        params,
    });
}
//我申请的列表
export function applyList(params) {
    return request({
        // url: `/wechat/manage/document/list`,
        url: `/wechat/manage/document/list/v3.6.0`,
        method: "GET",
        params,
    });
}
// 提交申请
export function submitApply(data) {
    return request({
        url: "/wechat/manage/submit",
        method: "POST",
        data,
    });
}
// 重新提交获取回显数据
export function getResubmitData(params) {
    return request({
        url: `/wechat/manage/reApply/check/${params}`,
        method: "GET",
    });
}

// 重新提交-提交接口
export function resubmitApply(data) {
    return request({
        url: "/wechat/manage/reApply",
        method: "POST",
        data,
    });
}

// 校验业务流程是否可用
export function checkFlowAble(processId) {
    return request({
        url: `/wechat/home/isAvailable?processId=${processId}`,
        method: "GET",
    });
}

// 终止流程
export function endProcessApi(params) {
    return request({
        url: `/wechat/manage/terminate/process`,
        method: "PUT",
        params,
    });
}

// 校验是否有可选择的业务流程
export const processCheck = () => {
    return request({
        url: '/wechat/home/process/check',
        method: 'GET'
    })
}

// 获取可选部门
export const getDeptList = () => {
    return request({
        url: '/wechat/home/dept/list',
        method: 'GET'
    })
}

// 获取业务流程
export const getProcess = (params) => {
    return request({
        url: '/wechat/home/process/list',
        method: 'GET',
        params
    })
}

export const sealDeatil = (params) => {
    return request({
        url:
            '/wechat/workspace/process/seal/detail'
        // 'https://yapi.libawall.com/mock/1543/seal'
        ,
        method: 'GET',
        params
    })
}
export const getDocumentStatus = (params) => {
    return request({
        url: '/wechat/push/message/documentStatus',
        method: 'GET',
        params
    })
}
// 获取远程确认人员信息
export const getRemoteInfo = (params) => {
    return request({
        url: `/wechat/home/remote/staff/${params}`,
        method: 'GET',
    })
}
// /wechat/stampdata/configure?number=xxx&documentId=
export const getLianXuConfig = (params) => {
    return request({
        url: `/common/document/lian_xu_config`,
        method: 'GET',
        params
    })
}
export const getStampData = (params) => {
    return request({
        url: `/wechat/stampdata/configure`,
        method: 'GET',
        params
    })
}
// 获取新视频列表
export const getNewStampVideoList = (params) => {
    return request({
        url: `/wechat/documentVideoNode`,
        method: 'GET',
        params
    })
}

// 获取新视频节点列表
export const getNewStampRelList = (params) => {
  return request({
    url: `/wechat/documentVideoNodeRel`,
    method: 'GET',
    params
  })
}
// 获取视频数量
export const getVideoSize = (params) => {
  return request({
    url: `/wechat/documentVideoNode/size`,
    method: 'GET',
    params
  })
}
